var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 0C9.74721 0 6.2998 3.4474 6.2998 7.7C6.2998 11.9526 9.74721 15.4 13.9998 15.4C18.2524 15.4 21.6998 11.9526 21.6998 7.7C21.6998 3.4474 18.2524 0 13.9998 0Z",
    fill: "#525252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18.2002C3.13401 18.2002 0 21.3342 0 25.2002V29.4002C0 30.1734 0.626808 30.8002 1.4 30.8002H26.6C27.3732 30.8002 28 30.1734 28 29.4002V25.2002C28 21.3342 24.866 18.2002 21 18.2002H7Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.868a36455c85a9cb35343e60d24bf56f.svg";
export { ForwardRef as ReactComponent };